import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { BaseOutlineParagraphProps } from '../OutlineParagraphPlugin.types';
import { defaultIsEmptyText, EditorPlaceHolder } from './EditorPlaceHolder';

const Main = styled.li`
  &.hide {
    display: none;
  }
`;

interface OutlineParagraphIdeaListItemProps extends BaseOutlineParagraphProps {}

export const OutlineParagraphIdeaListItem = (props: OutlineParagraphIdeaListItemProps) => {
  const { attributes, children, element, isReadOnly } = props;
  const isEmptyText = defaultIsEmptyText(element);
  return (
    <EditorPlaceHolder
      isEmptyText={() => isEmptyText}
      isReadOnly={isReadOnly}
      placeHolderText="viết, hoặc bấm enter để thêm bullet point"
    >
      <Main
        {...attributes}
        className={cl('outline-paragraph-idea-list-item-element', element.id, {
          hide: isEmptyText && isReadOnly,
        })}
      >
        {children}
      </Main>
    </EditorPlaceHolder>
  );
};
